import { useState } from 'react'
import { PropTypes } from 'prop-types'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import SearchBarWithSelect from 'components/SearchBarWithSelect'

import { SEARCH_BAR_ITEMS_OPTIONS } from 'resources'
import useDebounce from 'hooks/useDebounce'
import { loadFilteredItems } from 'store/Items/actions'
import { setQueryStringParameters } from 'store/AppState/actions'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'

const ListFilters = ({ queryStringParameters }) => {
  const [searchQuery, setSearchQuery] = useState(
    queryStringParameters?.searchFor
  )

  const history = useHistory()
  const dispatch = useDispatch()
  const { pathname } = useLocation()

  const redirectToAddNew = () =>
    history.push({ state: { itemUuid: 'new' } })

  const debouncedFetchItemsWithSearchParams = useDebounce(() => {
    const updatedParams = {
      ...queryStringParameters,
      page: 1,
      searchFor: searchQuery,
    }

    dispatch(loadFilteredItems(updatedParams))
    dispatch(setQueryStringParameters(updatedParams, pathname))
  }, 500)

  const handleSearch = (event) => {
    setSearchQuery(event.target.value)

    debouncedFetchItemsWithSearchParams()
  }

  const handleSelectSearchParam = (searchParam) => {
    const selectedOption = SEARCH_BAR_ITEMS_OPTIONS.find(
      ({ uuid }) => uuid === searchParam
    )

    dispatch(
      setQueryStringParameters(
        {
          ...queryStringParameters,
          searchFor: '',
          searchBy: selectedOption.uuid,
          page: 1,
        },
        pathname
      )
    )
  }

  const selectedSearchParam = SEARCH_BAR_ITEMS_OPTIONS.find(
    ({ uuid }) => uuid === queryStringParameters?.searchBy
  )

  return (
    <div className="items-filters">
      <SearchBarWithSelect
        selectedOption={selectedSearchParam}
        options={SEARCH_BAR_ITEMS_OPTIONS}
        handleSearch={handleSearch}
        handleSelectOption={handleSelectSearchParam}
        searchQuery={searchQuery}
      />
      <button
        className="btn new-item"
        type="button"
        onClick={redirectToAddNew}
      >
        <span className="new-item -cross"></span>
        <span className="new-item -cross"></span>
      </button>
    </div>
  )
}

ListFilters.propTypes = {
  queryStringParameters: PropTypes.shape({
    per: PropTypes.number,
    page: PropTypes.number,
    searchBy: PropTypes.string,
    searchFor: PropTypes.string,
    venueUuid: PropTypes.string,
  }),
}

export default ListFilters
